import { Link } from 'react-router-dom';

// Real Kalki AI logo (transparent PNG) — used as-is, no added text.
export function FullLogo({ height = 40, className = '' }) {
  return (
    <img
      src="/kalki-logo.png"
      alt="Kalki AI"
      data-testid="full-logo"
      style={{ height, width: 'auto', display: 'block' }}
      className={className}
    />
  );
}

// Cropped shield + horse mark — uses the clean square PNG asset.
export function ShieldMark({ size = 40, className = '' }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/shield.png`}
      alt="Kalki AI"
      className={className}
      style={{ width: size, height: size, objectFit: 'contain', display: 'block' }}
    />
  );
}

export function BrandLink({ height = 38 }) {
  return (
    <Link to="/" aria-label="Kalki AI home" className="inline-flex items-center" data-testid="brand-link">
      <span className="hidden sm:block"><FullLogo height={height} /></span>
      <span className="sm:hidden"><FullLogo height={30} /></span>
    </Link>
  );
}
